import {
  AfterViewChecked,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnChanges,
  OnInit,
  Renderer2,
  input,
} from '@angular/core';
import { NgbAccordionItem } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

import { DotCmsFacade } from '../../../facades/dot-cms.facade';
import { CustomDotCmsContentlet } from '../../../models/contentlet/custom-dotcms-contentlet.model';
import { DotCmsContentTypeComponent } from '../../../models/dot-cms-content-types-component.model';
import { filterEmaDotcmsPageLinks, onClickEmaDotcmsPageLinks } from '../../../utils/dot-cms-utils';

@Component({
  selector: 'custom-dot-cms-faq',
  templateUrl: './dot-cms-faq.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DotCmsFaqComponent implements DotCmsContentTypeComponent, OnChanges, OnInit, AfterViewChecked {
  readonly identifier = input<string>(undefined);
  lastPanelId: string;
  panelId: string;
  contentlet$: Observable<CustomDotCmsContentlet>;

  constructor(private dotCmsFacade: DotCmsFacade, private renderer: Renderer2, private el: ElementRef) {}

  ngOnChanges(): void {
    this.contentlet$ = this.dotCmsFacade.getContentletByIdentifier$(this.identifier());
  }
  ngOnInit() {
    onClickEmaDotcmsPageLinks(this.el, this.renderer);
    this.panelId = `panel-${this.identifier()}`;
  }
  ngAfterViewChecked() {
    filterEmaDotcmsPageLinks(this.el, this.renderer);
  }
  isOpened(item: NgbAccordionItem) {
    //@ts-ignore
    return item._collapsed;
  }
}
